export default __webpack_public_path__ + "static/media/wikipedia_key.75676a06.png";